import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-eliminazione',
  templateUrl: './eliminazione.component.html',
  styleUrls: ['./eliminazione.component.scss']
})
export class EliminazioneComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<EliminazioneComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  onAnulla() {
    this.dialogRef.close();
  }

  // On delete
  onElimina() {
    this.dialogRef.close({
      data: true
    });
  }

}

